import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedClassification } from 'contracts/Classifications';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_CLASSIFICATIONS_',
  }
);

export interface ListClassificationsState {
  data: ListedClassification[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListClassificationsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedClassification[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListClassificationsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListClassificationsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListClassificationsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListClassificationsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListClassificationsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listClassifications = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListClassificationsTypes = Types;
export const ListClassificationsActions = Creators;
